import {
  HOUR,
  isDefined,
  type WebhookHistoryInput,
  type WebhookHistorySuccess,
  type WebhookHistoryData,
  type WebhookHistoryItem,
} from '@terros/common'
import { useTantalimQuery } from '../query'
import { webhookHistoryKey } from '../keys'
import { type GetHookResponse } from '../hooks'

/** The web history page shows each payload, so it asks for them; the API omits them by default. */
export const useWebhookHistory = (input: WebhookHistoryInput): GetHookResponse<WebhookHistoryData[]> => {
  const withPayloads = { ...input, includePayload: true }
  return useTantalimQuery<WebhookHistoryInput, WebhookHistorySuccess, WebhookHistoryData[]>({
    queryKey: webhookHistoryKey(withPayloads),
    input: withPayloads,
    convertResponse: (data) => data.history.filter(hasPayload),
    url: '/webhook/history',
    options: {
      staleTime: HOUR,
      gcTime: 4 * HOUR,
    },
  })
}

function hasPayload(item: WebhookHistoryItem): item is WebhookHistoryData {
  return isDefined(item.payload)
}
